import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import {
  UncontrolledButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem,
} from 'reactstrap';
import SweetAlert from 'react-bootstrap-sweetalert';
import _ from 'lodash';

import addNotification from '../../../../components/notification';
import Table from '../../../../components/table/Table';

import ROUTES from '../../../../config/routes';

import { getDepartmentsList, deleteDepartment } from '../../../../app/store/actions/departments';

class DepartmentsList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showModalDelete: false,
      departmentUpdate: null,
    };

    this.defaultSorted = [
      {
        id: 'code',
        desc: false,
      },
    ];

    this.tableColumns = [
      {
        Header: I18n.t('BEE55' /* Ações */),
        accessor: 'action',
        style: { overflow: 'visible', alignSelf: 'center' },
        filterable: false,
        sortable: false,
        minWidth: 100,
        Cell: (rows) => (
          <div style={{ textAlign: 'center' }}>
            <button className="btn btn-default btn-xs">{I18n.t('BEE55' /* Ações */)}</button>
            <UncontrolledButtonDropdown>
              <DropdownToggle color="default" caret className="btn-xs" />
              <DropdownMenu>
                <DropdownItem onClick={() => this.showDepartmentDetail(rows.row)}>{I18n.t('BEE56' /* Detalhes */)}</DropdownItem>
                <DropdownItem onClick={() => this.showEditDepartment(rows.row)}>{I18n.t('BEE57' /* Editar */)}</DropdownItem>
                <DropdownItem onClick={() => this.showCopyDepartment(rows.row)}>{I18n.t('BEE80' /* Copiar */)}</DropdownItem>
                <DropdownItem onClick={() => this.showDeleteDepartment(rows.row)}>{I18n.t('BEE81' /* Eliminar */)}</DropdownItem>
              </DropdownMenu>
            </UncontrolledButtonDropdown>
          </div>
        ),
      }, {
        Header: I18n.t('BEE82' /* Código */),
        accessor: 'code',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
      }, {
        Header: I18n.t('BEE83' /* Nome */),
        id: 'name',
        accessor: 'name',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 200,
      }, {
        Header: I18n.t('BEE135' /* Observação */),
        accessor: 'note',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 200,
      },
    ];
  }

  componentDidMount() {
    this.maintainsState();
  }

  maintainsState = async () => {
    if (this.props.location.state && this.props.location.state.dice) {
      this.setState({
        page: this.props.location.state.dice.page,
        firstRun: true,
      });
      await this.getDepartments();
    } else {
      await this.getDepartments();
    }
  };

  setInitState = () => {
    this.setState({
      showModalDelete: false,
      departmentUpdate: null,
    });
  };

  getDepartments = async () => {
    await this.props.getDepartmentsList();
  };

  setValue = async (attr, value) => {
    await this.setState({
      [`${attr}`]: value,
    });
  };

  deleteDepartment = async (department) => {
    const result = await this.props.deleteDepartment(department._original.id);

    this.setInitState();
    if (result) {
      addNotification('success', I18n.t('BEE745' /* Eliminar Departamento */), I18n.t('BEE746', { 0: department.code } /* Departamento %{0} eliminado com sucesso! */), 'top-right');
    }
    await this.getDepartments();
  };

  showDepartmentDetail = (department) => {
    this.props.history.push({
      pathname: ROUTES.DEPARTMENT_DETAIL,
      state: {
        department: department._original,
      },
      dice: {
        page: this.state.page,
      },
    });
  };

  showEditDepartment = (department) => {
    this.props.history.push({
      pathname: ROUTES.DEPARTMENT_EDIT,
      state: {
        department: department._original,
      },
      dice: {
        page: this.state.page,
      },
    });
  };

  showCopyDepartment = (department) => {
    this.props.history.push({
      pathname: ROUTES.DEPARTMENT_COPY,
      state: {
        department: department._original,
      },
    });
  };

  showDeleteDepartment = (department) => {
    this.setState({ showModalDelete: true, departmentUpdate: department });
  };

  render() {
    const { departmentUpdate, showModalDelete, page } = this.state;
    const { departmentsList = [] } = this.props;

    return (
      <div>
        <div className="d-flex align-items-center">
          <ol className="breadcrumb float-xl-left">
            <li className="breadcrumb-item">
              <i className="fas fa-home fa-fw m-t-10 m-r-5" />
              {' '}
              {I18n.t('BEE12' /* Início */)}
            </li>
            <li className="breadcrumb-item">{I18n.t('BEE13' /* Administração */)}</li>
            <li className="breadcrumb-item">{I18n.t('BEE25' /* Usuários */)}</li>
            <li className="breadcrumb-item active">{I18n.t('BEE731' /* Departamentos */)}</li>
          </ol>
        </div>
        <Table
          downloadCSV
          wikiHelp={ROUTES.DEPARTMENT_HELP}
          headerTitle={I18n.t('BEE731' /* Departamentos */)}
          actionButtons={(
            <div className="ml-auto">
              <Link to={ROUTES.DEPARTMENT_CREATE} className="btn btn-success btn-sm btn-rounded pl-2 pr-3">
                <i className="fa fa-plus mr-1" />
                {' '}
                {I18n.t('BEE747' /* Incluir Departamento */)}
              </Link>
            </div>
          )}
          panelHeaderProps={{
            onClickReload: this.getDepartments,
          }}
          filterable
          data={departmentsList}
          columns={this.tableColumns}
          expander
          defaultPageSize={10}
          defaultSorted={this.defaultSorted}
          page={(page) || ((!this.state.firstRun && this.props.location.state && this.props.location.state.dice && this.props.location.state.dice.page) ? this.props.location.state.dice.page : page)}
          onPageChange={(page) => ((page >= 0) ? this.setState({ page }) : this.setState({ page: 0 }))}
          defaultFilterMethod={(filter, row) => {
            const input = _.lowerCase(filter.value);
            const value = _.lowerCase(row[filter.id]);
            if (_.includes(value, input)) {
              return true;
            }
          }}
        />
        {(showModalDelete
          && (
            <SweetAlert
              danger
              showCancel
              cancelBtnText={I18n.t('BEE99' /* Cancelar */)}
              confirmBtnText={I18n.t('BEE100' /* Confirmar */)}
              confirmBtnBsStyle="danger"
              cancelBtnBsStyle="default"
              title={I18n.t('BEE101' /* Você tem certeza? */)}
              onConfirm={() => this.deleteDepartment(departmentUpdate)}
              onCancel={() => this.setInitState()}
            >
              {I18n.t('BEE751', { 0: departmentUpdate.code } /* O departamento %{0} será eliminado! */)}
            </SweetAlert>
          )
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  departmentsList: state.departments && state.departments.departmentsList,
});

const mapDispatchToProps = (dispatch) => ({
  getDepartmentsList: () => dispatch(getDepartmentsList()),
  deleteDepartment: (departmentId) => dispatch(deleteDepartment(departmentId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DepartmentsList));
